import React from "react";
import { Form } from "react-bootstrap";

function SelectManyCheckbox({ 
    id, name,
    value, 
    onChange, onSelect, 
    options = [],

    formatLabel = option => option,
    formatValue = option => option,

    converter = {
        input: input => input,
        output: output => output
    },
    className = "w-100 d-flex justify-content-start",
    style = {}
}) {

    function isChecked(option) {
        return value && converter.input(value).indexOf(formatValue(option)) >= 0
    }

    function toggle(option) {
        let array = value ? [...converter.input(value)] : [];
        
        const optionValue = formatValue(option)
        const index = array.indexOf(optionValue);

        if(index >= 0) array.splice(index, 1);
        else array.push(optionValue);


        if(onChange) onChange({ target: { id, name, value: converter.output(array) }});
        if(onSelect) onSelect(converter.output(array));
    }

    return (
        <div className={className} style={style}>
            {options.map(option => (
                <Form.Check inline
                    defaultChecked={isChecked(option)}
                    type="checkbox"
                    id={`${id}-checkbox-${JSON.stringify(formatValue(option))}`}
                    label={formatLabel(option)} 
                    onChange={() => toggle(option)}
                />
            ))}
        </div>
    );
}

SelectManyCheckbox.StringConverter = {
    input: input => input.split(","),
    output: output => output.join(",")
};

export default SelectManyCheckbox;